import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";
import { endpoints } from "../services/apis";
import { makeUnauthenticatedPOSTRequest } from "../services/serverHelper";
import { useDispatch } from "react-redux";
import {
  setAccessToken,
  setRole,
  setRefreshToken,
  setprofileCompleted
} from "../reducer/slices/authSlice";

import logo from "../../assets/ek-logo.png";
import patronBg from "../../assets/patron-bg.png"; // Update with your patron background image
import Footer from "../../components/Footer";
import "./Patronlogin.css";

// Google Login imports
import { GoogleLogin } from "@react-oauth/google";
import { jwtDecode } from "jwt-decode";

export function PatronLoginPage() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });

  const [passwordVisible, setPasswordVisible] = useState(false);

  // Forgot password states
  const [showForgotModal, setShowForgotModal] = useState(false);
  const [forgotMobile, setForgotMobile] = useState("");
  const [forgotOtp, setForgotOtp] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [forgotStageSent, setForgotStageSent] = useState(false);
  const [otpVerified, setOtpVerified] = useState(false);

  const FORGOT_BASE = "https://api.ekalakaar.com/api/v1/auth/forgot-password";

  useEffect(() => {
    const prefillEmail = localStorage.getItem("prefill_email");
    if (prefillEmail) {
      setFormData((prev) => ({
        ...prev,
        email: prefillEmail || "",
      }));
      localStorage.removeItem("prefill_email");
    }
  }, []);

  function changeHandler(event) {
    const { name, value } = event.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  }

  const togglePasswordVisibility = () => setPasswordVisible(!passwordVisible);

  // Email/password login handler
  const submitHandler = async (event) => {
    event.preventDefault();
    if (!formData.email || !formData.password) {
      return toast.error("Please enter both email and password");
    }

    const toastId = toast.loading("Logging in...");
    try {
      const response = await makeUnauthenticatedPOSTRequest(
        endpoints.LOGIN_API,
        {
          email: formData.email,
          password: formData.password,
          registerBy: "email",
        }
      );
      toast.dismiss(toastId);

      if (!response || response.error || response.status !== "success") {
        toast.error(
          response?.message ||
            response?.error ||
            "Login failed. Please check your credentials and try again."
        );
        return;
      }

      const data = response.data || {};

      if (!data.accessToken || !data.refreshToken) {
        toast.error("Login failed. Try again.");
        return;
      }

      if (data.role !== "Patron") {
        toast.error("Only Patrons can login here");
        return;
      }

      dispatch(setAccessToken(data.accessToken));
      dispatch(setRefreshToken(data.refreshToken));
      // dispatch(setRefreshToken(id));
      dispatch(setprofileCompleted(data.profileCompleted));
      dispatch(setRole(data.role));

      localStorage.setItem("accessToken", data.accessToken);
      localStorage.setItem("refreshToken", data.refreshToken);
      localStorage.setItem("artId", data.id);
      localStorage.setItem("role", data.role);
      localStorage.setItem("email", data.email);
      localStorage.setItem("name", data.name);
      localStorage.setItem('profileCompleted',data.profileCompleted);
      

      toast.success("Login successful!");
      if(response.data.profileCompleted){
        navigate("/PatronDashboard"); // Update with your patron dashboard route
      }else{
        navigate("/patron-dashboard"); // Update with your patron dashboard route
      } 
    } catch (error) {
      toast.dismiss(toastId);
      console.error("Login error:", error);
      toast.error("Error logging in. Please try again.");
    }
  };

  // Google Sign-In handler
  const handleGoogleLoginSuccess = async (credentialResponse) => {
    try {
      const decoded = jwtDecode(credentialResponse.credential);
      console.log("Google User Info:", decoded);

      const toastId = toast.loading("Logging in with Google...");
      const response = await makeUnauthenticatedPOSTRequest(
        endpoints.LOGIN_WITH_EMAIL,
        {
          email: decoded.email,
          googleIdToken: credentialResponse.credential,
          registerBy: "google",
        }
      );
      toast.dismiss(toastId);

      if (!response || response.error || response.status !== "success") {
        toast.error(
          response?.message ||
            response?.error ||
            "Google login failed. Please try again."
        );
        return;
      }

      const { accessToken, refreshToken, role } = response.data || {};

      if (!accessToken || !refreshToken) {
        toast.error("Google login failed. Try again.");
        return;
      }

      if (role !== "Patron") {
        toast.error("Only Patrons can login here");
        return;
      }

      dispatch(setAccessToken(accessToken));
      dispatch(setRefreshToken(refreshToken));
      dispatch(setRole(role));

      localStorage.setItem("accessToken", accessToken);
      localStorage.setItem("refreshToken", refreshToken);
      localStorage.setItem("role", role);

      toast.success("Google login successful!");
      navigate("/Patron_Profile"); // Update with your patron dashboard route
    } catch (error) {
      console.error("Google login error:", error);
      toast.error("Google login failed");
    }
  };

  const handleGoogleLoginError = () => {
    toast.error("Google login failed");
  };

  // Forgot password handlers

  // STEP 1: Send OTP for Forgot Password
  const handleForgotSendOtp = async () => {
    if (!forgotMobile) return toast.error("Please enter your mobile number");

    const toastId = toast.loading("Sending OTP...");
    try {
      const res = await fetch(`${FORGOT_BASE}/send-otp`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          mobileNu: forgotMobile,
          registerBy: "mobile",
        }),
      });
      const data = await res.json();
      toast.dismiss(toastId);
      if (res.status === 200) {
        toast.success("OTP sent successfully to your mobile!");
        setForgotStageSent(true);
      } else {
        toast.error(data.message || "Failed to send OTP");
      }
    } catch (err) {
      toast.dismiss(toastId);
      toast.error("Error sending OTP: " + err.message);
    }
  };

  // STEP 2: Verify OTP (Forgot Password)
  const handleVerifyForgotOtp = async () => {
    if (!forgotOtp) return toast.error("Please enter OTP");

    const toastId = toast.loading("Verifying OTP...");
    try {
      const res = await fetch(`${FORGOT_BASE}/verify-otp`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ otp: forgotOtp }),
        credentials: "include",
      });

      const data = await res.json();
      toast.dismiss(toastId);

      if (res.status === 200) {
        toast.success("OTP verified! Now set your new password.");
        setOtpVerified(true);
        localStorage.setItem("tempAccessToken", data.data.accessToken);
      } else {
        toast.error(data.message || "Invalid OTP");
      }
    } catch (err) {
      toast.dismiss(toastId);
      toast.error("Error verifying OTP: " + err.message);
    }
  };

  // STEP 3: Reset Password
  const handleResetPassword = async () => {
    if (!newPassword) return toast.error("Please enter your new password");

    const toastId = toast.loading("Updating password...");
    try {
      const res = await fetch(`${FORGOT_BASE}/reset-password`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("tempAccessToken")}`,
        },
        body: JSON.stringify({
          password: newPassword,
          passwordConfirm: newPassword,
        }),
      });

      const data = await res.json();
      toast.dismiss(toastId);

      if (res.status === 200) {
        toast.success("Password updated successfully!");
        localStorage.removeItem("tempAccessToken");
        setShowForgotModal(false);
        setForgotStageSent(false);
        setOtpVerified(false);
        setForgotOtp("");
        setNewPassword("");
        setForgotMobile("");
        setTimeout(() => navigate("/Patronlogin"), 1500);
      } else {
        toast.error(data.message || "Failed to reset password");
      }
    } catch (err) {
      toast.dismiss(toastId);
      toast.error("Error updating password: " + err.message);
    }
  };

  // ---------------------- UI ------------------------

  return (
    <>
      <div className="patron-login-wrapper">
        {/* Background */}
        <div className="patron-login-background">
          <img
            src={patronBg}
            alt="background"
            className="patron-bg-image"
          />
          <div className="patron-bg-overlay"></div>
        </div>

        {/* Login Card */}
        <div className="patron-login-content">
          <div className="patron-login-card">
            <div className="patron-login-header">
              <img src={logo} alt="logo" className="patron-logo" />
              <h2 className="patron-login-title">
                Sign in to Patron Portal
              </h2>
            </div>

            <form onSubmit={submitHandler} className="patron-login-form">
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={changeHandler}
                placeholder="Enter your email"
                className="patron-input"
              />

              <div className="patron-password-wrapper">
                <input
                  type={passwordVisible ? "text" : "password"}
                  name="password"
                  required
                  onChange={changeHandler}
                  value={formData.password}
                  className="patron-input"
                  placeholder="Enter your password"
                />
                <button
                  type="button"
                  onClick={togglePasswordVisibility}
                  className="patron-password-toggle"
                >
                  <i
                    className={`fas ${
                      passwordVisible ? "fa-eye-slash" : "fa-eye"
                    }`}
                  ></i>
                </button>
              </div>

              <p
                onClick={() => setShowForgotModal(true)}
                className="patron-forgot-link"
              >
                Forgot password?
              </p>

              <button
                type="submit"
                className="patron-submit-btn"
              >
                Sign In
              </button>
            </form>

            {/* Google Sign-In Button */}
            <div className="patron-google-login">
              <GoogleLogin
                onSuccess={handleGoogleLoginSuccess}
                onError={handleGoogleLoginError}
              />
            </div>

            <p className="patron-signup-text">
              Don't have an account?{" "}
              <span
                onClick={() => navigate("/patron-register")}
                className="patron-signup-link"
              >
                Sign up
              </span>
            </p>
          </div>
        </div>
      </div>

      {/* Forgot Password Modal */}
      {showForgotModal && (
        <div className="patron-modal-overlay">
          <div className="patron-modal">
            {!forgotStageSent ? (
              <>
                <h3 className="patron-modal-title">
                  Forgot Password
                </h3>
                <input
                  type="number"
                  placeholder="Enter your mobile number"
                  value={forgotMobile}
                  onChange={(e) => setForgotMobile(e.target.value)}
                  className="patron-modal-input"
                />
                <button
                  onClick={handleForgotSendOtp}
                  className="patron-modal-btn"
                >
                  Send OTP
                </button>
                <button
                  onClick={() => setShowForgotModal(false)}
                  className="patron-modal-cancel"
                >
                  Cancel
                </button>
              </>
            ) : !otpVerified ? (
              <>
                <h3 className="patron-modal-title">
                  Verify OTP
                </h3>
                <input
                  type="text"
                  placeholder="Enter OTP"
                  maxLength={6}
                  value={forgotOtp}
                  onChange={(e) => setForgotOtp(e.target.value)}
                  className="patron-modal-input patron-otp-input"
                />
                <button
                  onClick={handleVerifyForgotOtp}
                  className="patron-modal-btn"
                >
                  Verify OTP
                </button>
              </>
            ) : (
              <>
                <h3 className="patron-modal-title">
                  Reset Password
                </h3>
                <input
                  type="password"
                  placeholder="Enter new password"
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                  className="patron-modal-input"
                />
                <button
                  onClick={handleResetPassword}
                  className="patron-modal-btn"
                >
                  Update Password
                </button>
              </>
            )}
          </div>
        </div>
      )}

      <Footer />
    </>
  );
}

export default PatronLoginPage;